import React from "react";
import BoxComponent from "../../../components/Box/BoxComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import SvgComponent from "../../../components/Image/SvgComponent";
import ListComponent from "../../../components/List/ListComponent";
import { formatNumberToDinheiro } from "../../../utils/dinheiro";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import ImageComponent from "../../../components/Image/ImageComponent";
import MailboxIcon from "../../../assets/icons/mailbox.png";
import { ReactComponent as PersonIcon } from "../../../assets/icons/perfil.svg";
import { ReactComponent as LocationIcon } from "../../../assets/icons/location.svg";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock.svg";
import { InfoPedidoProps } from "../PedidosPage";
import { getHoras } from "../../../utils/datas";
import { pedidoService } from "../../../service/PedidoService";
import { removeCaracteresEspeciais } from "../../../utils/texto";

interface DetalhePedidoProps {
    infoPedido?: InfoPedidoProps;
    onClick?: (id: number) => void;
    onClickCancelamentoPedido: (id: number) => void;
}

const DetalhePedidoComponent = (props: DetalhePedidoProps) => {
    const tratativaEtapa = (infoPedido: InfoPedidoProps) => {
        if (infoPedido.isConcluido || infoPedido.isCancelado) return <></>

        return <>
            {infoPedido.isPermitidoCancelar && (
                <ButtonComponent
                    id="acao_cancelar_pedido"
                    sx={{
                        backgroundColor: "#FF4258",
                        boxShadow: "0px 2px 8px 0px #3D281714",
                        color: "#FFFFFF",
                        borderRadius: 2,
                        width: "95%"
                    }}
                    onClick={() => props.infoPedido?.id && props.onClickCancelamentoPedido?.(props.infoPedido.id)}
                >
                    Cancelar
                </ButtonComponent>
            )}
            {infoPedido.isPermitidoConfirmar && (
                <ButtonComponent
                    id="acao_avancar_pedido"
                    sx={{
                        backgroundColor: "#FF8C42",
                        boxShadow: "0px 2px 8px 0px #3D281714",
                        color: "#FFFFFF",
                        borderRadius: 2,
                        width: "95%"
                    }}
                    onClick={() => props.infoPedido?.id && props.onClick?.(props.infoPedido.id)}
                >
                    Confirmar
                </ButtonComponent>
            )}
        </>
    }

    if (props.infoPedido) {
        const textoSemCaracteres = removeCaracteresEspeciais(props.infoPedido?.status);
        const cores = pedidoService.getCoresPorStatus(textoSemCaracteres.toUpperCase());

        return <>
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "90%",
                    overflowX: "hidden",
                    overflowY: "auto"
                }}
            >
                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        // width: "100%",
                        flex: 1,
                        padding: 2,
                        gap: 2
                    }}
                >
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "0.89px solid  #E8DFD5",
                            gap: 0.6,
                            pb: 1
                        }}
                    >
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 600,
                                fontSize: '11.3px',
                                lineHeight: '16px',
                                letterSpacing: '0em',
                                color: '#7A6B63',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            Pedido
                        </TypographyComponent>
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 2", sans-serif',
                                fontWeight: 700,
                                fontSize: '18px',
                                lineHeight: '28px',
                                letterSpacing: '0em',
                                color: '#3D2817',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            #{props.infoPedido.id}
                        </TypographyComponent>
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                opacity: 1,
                                transform: 'rotate(0deg)',
                                px: 1.2,
                                borderRadius: '33554400px',
                                border: `1px solid ${cores.borderColor}`,
                                boxSizing: 'border-box',
                                background: cores.backgroundColor,
                                width: "fit-content"
                            }}
                        >
                            <TypographyComponent
                                variant="body2" fontWeight="bold"
                                sx={{
                                    fontFamily: '"Font 2", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    lineHeight: '24px',
                                    letterSpacing: '0em',
                                    display: 'flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none',
                                    color: cores.color,
                                }}
                            >
                                {props.infoPedido.status}
                            </TypographyComponent>
                        </BoxComponent>
                    </BoxComponent>
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "0.89px solid  #E8DFD5",
                            gap: 0.6,
                            pb: 1
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%"
                            }}
                        >
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '11.3px',
                                    lineHeight: '16px',
                                    letterSpacing: '0em',
                                    color: '#7A6B63',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                Tipo
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '13.1px',
                                    lineHeight: '20px',
                                    letterSpacing: '0em',
                                    color: '#3D2817',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                {props.infoPedido.tipo}
                            </TypographyComponent>
                        </BoxComponent>
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%"
                            }}
                        >
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '11.3px',
                                    lineHeight: '16px',
                                    letterSpacing: '0em',
                                    color: '#7A6B63',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                Canal
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '13.1px',
                                    lineHeight: '20px',
                                    letterSpacing: '0em',
                                    color: '#3D2817',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'capitalize'
                                }}
                            >
                                {props.infoPedido.canal}
                            </TypographyComponent>
                        </BoxComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "0.89px solid  #E8DFD5",
                            gap: 0.6,
                            pb: 1
                        }}
                    >
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 600,
                                fontSize: '10.9px',
                                lineHeight: '16px',
                                letterSpacing: '0em',
                                color: '#7A6B63',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            Cliente
                        </TypographyComponent>
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                gap: 1
                            }}
                        >
                            <BoxComponent
                                component="div"
                                sx={{
                                    display: "flex",
                                }}
                            >
                                <SvgComponent
                                    icon={<PersonIcon />}
                                    key={"cliente-icon"}
                                    sx={{
                                        width: 16,
                                        height: 16,
                                        stroke: "#FF8C42"
                                    }}
                                />
                            </BoxComponent>
                            <BoxComponent
                                component="div"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.6
                                }}
                            >
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 600,
                                        fontSize: '12.9px',
                                        lineHeight: '20px',
                                        letterSpacing: '0em',
                                        color: '#3D2817',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: 'none'
                                    }}
                                >
                                    {props.infoPedido.infoSolicitante.nome}
                                </TypographyComponent>
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 400,
                                        fontSize: '12.7px',
                                        lineHeight: '20px',
                                        letterSpacing: '0em',
                                        color: '#3D2817',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: 'none'
                                    }}
                                >
                                    {props.infoPedido.infoSolicitante.telefoneCompleto}
                                </TypographyComponent>
                            </BoxComponent>
                        </BoxComponent>
                    </BoxComponent>

                    {props.infoPedido.endereco && (
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                borderBottom: "0.89px solid  #E8DFD5",
                                gap: 0.6,
                                pb: 1
                            }}
                        >
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '10.9px',
                                    lineHeight: '16px',
                                    letterSpacing: '0em',
                                    color: '#7A6B63',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                Endereço de Entrega
                            </TypographyComponent>
                            <BoxComponent
                                component="div"
                                sx={{
                                    display: "flex",
                                    gap: 2
                                }}
                            >
                                <SvgComponent
                                    icon={<LocationIcon />}
                                    key={"location-icon"}
                                    sx={{
                                        width: 16,
                                        height: 16,
                                        color: "#FF8C42"
                                    }}
                                />
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 400,
                                        fontSize: '12.7px',
                                        lineHeight: '20px',
                                        letterSpacing: '0em',
                                        color: '#3D2817',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: 'none'
                                    }}
                                >
                                    {props.infoPedido.endereco.enderecoCompleto}
                                </TypographyComponent>
                            </BoxComponent>
                        </BoxComponent>
                    )}

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "0.89px solid  #E8DFD5",
                            gap: 0.6,
                            pb: 1
                        }}
                    >
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 600,
                                fontSize: '10.9px',
                                lineHeight: '16px',
                                letterSpacing: '0em',
                                color: '#7A6B63',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            Horário previsto
                        </TypographyComponent>
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                gap: 2
                            }}
                        >
                            <SvgComponent
                                icon={<ClockIcon />}
                                key={"time-icon"}
                                sx={{
                                    width: 16,
                                    height: 16,
                                    color: "#FF8C42"
                                }}
                            />
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '12.1px',
                                    lineHeight: '20px',
                                    letterSpacing: '0em',
                                    color: '#3D2817',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                {getHoras(new Date(props.infoPedido.dataPrevista))}
                            </TypographyComponent>
                        </BoxComponent>
                    </BoxComponent>
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "0.89px solid  #E8DFD5",
                            gap: 0.6,
                            pb: 1
                        }}
                    >
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 600,
                                fontSize: '10.9px',
                                lineHeight: '16px',
                                letterSpacing: '0em',
                                color: '#7A6B63',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            Itens
                        </TypographyComponent>

                        <ListComponent
                            sx={{
                                listStyle: "initial",
                                p: 0,
                                pl: 3
                            }}
                            list={props.infoPedido.itens}
                            renderItem={(item) => {
                                const isComplementos = item.complementos || item.complementosEspecificos;

                                return <BoxComponent component={"div"} sx={{ display: "flex", flexDirection: "column" }}>
                                    {item.opcao && (
                                        <TypographyComponent variant="caption">
                                            Opção: {item.opcao.nome}
                                        </TypographyComponent>
                                    )}

                                    {isComplementos && (
                                        <>
                                            <TypographyComponent variant="caption">
                                                Complementos:
                                            </TypographyComponent>
                                            {item.complementos?.map(c => (
                                                <TypographyComponent
                                                    key={c.id}
                                                    variant="caption"
                                                >
                                                    + {c.nome}
                                                </TypographyComponent>
                                            ))}

                                            {item.complementosEspecificos?.map(c => (
                                                <TypographyComponent
                                                    key={c.id}
                                                    variant="caption"
                                                >
                                                    + {c.nome}
                                                </TypographyComponent>
                                            ))}
                                        </>
                                    )}
                                </BoxComponent>
                            }}
                        />
                    </BoxComponent>

                    {props.infoPedido.observacao !== "" && props.infoPedido.observacao !== null && (
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                borderBottom: "0.89px solid  #E8DFD5",
                                gap: 0.6,
                                pb: 1
                            }}
                        >
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '10.9px',
                                    lineHeight: '16px',
                                    letterSpacing: '0em',
                                    color: '#7A6B63',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                Observações
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '12.1px',
                                    lineHeight: '20px',
                                    letterSpacing: '0em',
                                    color: '#3D2817',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                {props.infoPedido.observacao}
                            </TypographyComponent>
                        </BoxComponent>
                    )}

                    {/* SECAO DE VALORES */}
                    <BoxComponent component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "0.89px solid  #E8DFD5",
                            pb: 1
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.6,
                            }}
                        >
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '10.9px',
                                    lineHeight: '16px',
                                    letterSpacing: '0em',
                                    color: '#7A6B63',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                Valor
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 700,
                                    fontSize: '17px',
                                    lineHeight: '28px',
                                    letterSpacing: '0em',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none',
                                    color: "#FF8C42"
                                }}
                            >
                                {formatNumberToDinheiro(props.infoPedido.valor)}
                            </TypographyComponent>
                        </BoxComponent>
                        {props.infoPedido.vlrTroco !== 0 && (
                            <BoxComponent
                                component="div"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.6,
                                }}
                            >
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 600,
                                        fontSize: '10.9px',
                                        lineHeight: '16px',
                                        letterSpacing: '0em',
                                        color: '#7A6B63',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: 'none'
                                    }}
                                >
                                    Troco
                                </TypographyComponent>
                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 700,
                                        fontSize: '17px',
                                        lineHeight: '28px',
                                        letterSpacing: '0em',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: 'none',
                                        color: "#FF8C42"
                                    }}
                                >
                                    {formatNumberToDinheiro(props.infoPedido.vlrTroco)}
                                </TypographyComponent>
                            </BoxComponent>
                        )}
                    </BoxComponent>
                </BoxComponent>
            </BoxComponent>
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "10%",
                    gap: 2
                }}
            >
                {tratativaEtapa(props.infoPedido)}
            </BoxComponent>
        </>
    }

    return <>
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#F8F5F0",
                borderRadius: "8px",
                width: 64,
                height: 64
            }}
        >
            <ImageComponent
                alt="mailbox-pedido"
                src={MailboxIcon}
                sx={{
                    width: 64,
                    height: 64
                }}
            />
        </BoxComponent>
        <TypographyComponent
            variant="h3" fontWeight="bold"
            sx={{
                fontFamily: '"Font 2", sans-serif',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '0em',
                textAlign: 'center',
                color: '#3D2817',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                verticalAlign: 'middle',
                textTransform: 'none'
            }}
        >
            Nenhum pedido selecionado
        </TypographyComponent>
        <TypographyComponent
            variant="body2"
            sx={{
                fontFamily: '"Font 1", sans-serif',
                fontWeight: 400,
                fontSize: '11.3px',
                lineHeight: '16px',
                letterSpacing: '0em',
                textAlign: 'center',
                color: '#7A6B63',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                verticalAlign: 'middle',
                textTransform: 'none'
            }}
        >
            Clique em um pedido para ver os detalhes
        </TypographyComponent>
    </>
}

export default DetalhePedidoComponent;